<template>
    <ul
        v-if="visible"
        class="patsnap-biz-user-banner"
    >
        <!-- <li
            v-if="account.companyName"
            class="patsnap-biz-user-banner__company-name"
        >
            {{ account.companyName }}
        </li> -->
        <slot name="username">
            <li
                v-if="account.username"
                class="patsnap-biz-user-banner__item"
            >
                {{ account.username }}
            </li>
        </slot>

        <li
            v-if="account.email"
            class="patsnap-biz-user-banner__item"
        >
            {{ account.email }}
        </li>
        <li
            v-if="account.mobileNumber"
            class="patsnap-biz-user-banner__item"
        >
            {{ account.mobileNumber }}
        </li>

        <slot
            name="userPackageType"
        />
        <li class="patsnap-biz-user-banner__divider" />
    </ul>
</template>

<script>
/**
 * https://patsnap.atlassian.net/browse/PBI-3253
 * https://lanhuapp.com/url/8xi0v-UOeZh
 */
export default {
    name: 'UserBanner',
    props: {
        // eslint-disable-next-line vue/require-default-prop
        account: {
            type: Object,
            required: false,
        },
    },
    computed: {
        visible() {
            if (!this.account) return false;
            return !(!this.account.companyName
                && !this.account.username
                && !this.account.email
                && !this.account.mobileNumber);
        },
    },
};
</script>
